import * as OpKinds from '../opKinds';
import * as Types from '../model/types';

const artifactArgTypes = {
  artifactMembership: 'artifactMembership' as const,
};

export const opArtifactMembershipId = OpKinds.makeStandardOp({
  hidden: true,
  name: 'artifactMembership-id',
  argTypes: artifactArgTypes,
  returnType: inputTypes => 'string',
  resolver: ({artifactMembership}) => artifactMembership.id,
});

export const opArtifactMembershipCollection = OpKinds.makeStandardOp({
  hidden: true,
  name: 'artifactMembership-collection',
  argTypes: artifactArgTypes,
  returnType: inputTypes => 'artifact',
  resolver: ({artifactMembership}) => artifactMembership.artifactCollection,
});

export const opArtifactMembershipArtifactVersion = OpKinds.makeStandardOp({
  hidden: true,
  name: 'artifactMembership-artifactVersion',
  argTypes: artifactArgTypes,
  returnType: inputTypes => 'artifactVersion',
  resolver: ({artifactMembership}) => artifactMembership.artifact,
});

export const opArtifactMembershipCreatedAt = OpKinds.makeStandardOp({
  hidden: true,
  name: 'artifactMembership-createdAt',
  argTypes: artifactArgTypes,
  returnType: inputTypes => ({type: 'timestamp', unit: 'ms'}),
  resolver: ({artifactMembership}) => artifactMembership.createdAt,
});

export const opArtifactMembershipCommitHash = OpKinds.makeStandardOp({
  hidden: true,
  name: 'artifactMembership-commitHash',
  argTypes: artifactArgTypes,
  returnType: inputTypes => 'string',
  resolver: ({artifactMembership}) => artifactMembership.commitHash,
});

export const opArtifactMembershipVersionIndex = OpKinds.makeStandardOp({
  hidden: true,
  name: 'artifactMembership-versionIndex',
  argTypes: artifactArgTypes,
  returnType: inputTypes => 'number',
  resolver: ({artifactMembership}) => artifactMembership.versionIndex,
});

export const opArtifactMembershipArtifactAliases = OpKinds.makeStandardOp({
  hidden: true,
  name: 'artifactMembership-aliases',
  argTypes: artifactArgTypes,
  returnType: inputTypes => Types.list('artifactAlias'),
  resolver: ({artifactMembership}) => artifactMembership.aliases,
});
